if (!customElements.get('header-region-button')) {
  class HeaderRegionButton extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-region-dialog-trigger]');
      if (!this.button) return;
      this.button.addEventListener('click', () => this.openDialog());
    }

    openDialog() {
      const modal = document.querySelector('[data-eu-localization-modal]');
      if (modal && typeof modal.show === 'function') modal.show(this.button);
    }
  }

  customElements.define('header-region-button', HeaderRegionButton);
}
